import { ButtonProps } from '@chakra-ui/react'
import LoginButton from './LoginButton'
import { useAccount } from '../hooks/useAccount'
import { useLingui } from '@lingui/react/macro'
import { memo } from 'react'

const RushSellButton = memo(
  ({ from = 'rushb', ...props }: { from?: 'rushb' | 'detail' } & ButtonProps) => {
    const { t } = useLingui()
    const { onClick, ...restProps } = props
    return (
      <LoginButton
        variant={'blueOutline'}
        gap={['5px', '10px']}
        fontSize={['xs', 'sm', 'md']}
        size={from === 'detail' ? ['md'] : ['sm']}
        onClick={onClick}
        sx={{
          '&:disabled': {
            opacity: 1,
            cursor: 'not-allowed',
            _hover: {
              bg: 'inherit', // Prevents hover background change
            },
          },
        }}
        {...restProps}
      >
        {t`Sell`}
      </LoginButton>
    )
  },
)

export default RushSellButton
